import { toTimelineEndOffset, toTimelineStartOffset } from './timeline';

export function eventsOverlap<
  T extends { startMinutes: number; endMinutes: number },
>(a: T, b: T): boolean {
  const aStart = toTimelineStartOffset(a.startMinutes);
  const aEnd = toTimelineEndOffset(a.endMinutes, a.startMinutes);
  const bStart = toTimelineStartOffset(b.startMinutes);
  const bEnd = toTimelineEndOffset(b.endMinutes, b.startMinutes);

  return aStart < bEnd && bStart < aEnd;
}

function canFitInLane<T extends { startMinutes: number; endMinutes: number }>(
  lane: Array<T>,
  event: T,
): boolean {
  return !lane.some((existing) => eventsOverlap(existing, event));
}

export function packEventsIntoLanes<
  T extends { startMinutes: number; endMinutes: number },
>(events: Array<T>): Array<Array<T>> {
  const sorted = [...events].sort(
    (a, b) =>
      toTimelineStartOffset(a.startMinutes) -
        toTimelineStartOffset(b.startMinutes) ||
      toTimelineEndOffset(a.endMinutes, a.startMinutes) -
        toTimelineEndOffset(b.endMinutes, b.startMinutes),
  );

  const lanes: Array<Array<T>> = [];

  for (const event of sorted) {
    const targetLane = lanes.find((lane) => canFitInLane(lane, event));

    if (targetLane) {
      targetLane.push(event);
    } else {
      lanes.push([event]);
    }
  }

  return lanes;
}
